import { render, staticRenderFns } from "./chat-info.vue?vue&type=template&id=28cd0ff9&scoped=true"
import script from "./chat-info.vue?vue&type=script&lang=js"
export * from "./chat-info.vue?vue&type=script&lang=js"
import style0 from "./chat-info.vue?vue&type=style&index=0&id=28cd0ff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd0ff9",
  null
  
)

export default component.exports